import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { MOCKED_COUNTRY_SPECIFIC_SETTINGS } from 'src/testing/mocks/configuration.service.mock';
import { ApiInterceptor } from '../interceptors/api/api.interceptor';
import { HttpErrorInterceptor } from '../interceptors/http-error/http-error.interceptor';
import { ApiService } from '../services/api/api.service';
import { CartService } from '../services/api/cart/cart.service';
import { ConfigurationService } from '../services/api/configuration/configuration.service';
import { ECPService } from '../services/api/ecp/ecp.service';
import { OrderService } from '../services/api/order/order.service';
import { PersonalizationService } from '../services/api/personalization/personalization.service';
import { ProductsService } from '../services/api/products/products.service';
import { SmartlifeService } from '../services/api/smartlife/smartlife.service';
import { GenericStorageService } from '../services/storage/generic-storage.service';
import { UserDataService } from '../services/user-data/user-data.service';
import { MOCK_STORAGE, MockStorage } from '../../testing/mock-switch/mock-switch.component';
import { LOCAL_USER_DATA_STORAGE } from '../shared/injection-token/local-user-data.token';
import { ConfigurationStore } from '../state-management/stores/configuration.store';
import { ECPStore } from '../state-management/stores/ecp.store';
import { LocalUserDataMap } from '../types/interfaces/local-user-data.interface';
import { configServiceFactory } from './config-service-factory';
import { initOEFactory } from './init-oe-factory';

@NgModule({
	imports: [OAuthModule.forRoot(), TranslocoModule],
	exports: [CommonModule],
})
export class CoreModule {
	public static forRoot(): ModuleWithProviders<CoreModule> {
		return {
			ngModule: CoreModule,
			providers: [
				{
					provide: MOCK_STORAGE,
					useValue: new GenericStorageService<MockStorage>('MOCK_STORAGE', localStorage, {
						mockMode: false,
						values: [...MOCKED_COUNTRY_SPECIFIC_SETTINGS],
					}),
				},
				{
					provide: LOCAL_USER_DATA_STORAGE,
					useValue: new GenericStorageService<LocalUserDataMap>('user_data', localStorage),
				},
				{
					provide: ConfigurationService,
					useFactory: configServiceFactory,
					deps: [MOCK_STORAGE],
				},
				{
					provide: APP_INITIALIZER,
					useFactory: initOEFactory,
					deps: [OAuthService, ECPStore, ConfigurationStore],
					multi: true,
				},
				provideHttpClient(),
				UserDataService,
				ApiService,
				ECPService,
				ProductsService,
				PersonalizationService,
				OrderService,
				CartService,
				SmartlifeService,
				{ provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
				{ provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
			],
		};
	}
}
